import { Font } from '@react-pdf/renderer';
import interRegular from '../../../assets/fonts/inter/Inter-Regular.ttf?url';
import interSemiBold from '../../../assets/fonts/inter/Inter-SemiBold.ttf?url';
import interBold from '../../../assets/fonts/inter/Inter-Bold.ttf?url';

export const REPORT_FONT_FAMILY = 'Inter';

let registered = false;

// react-pdf holds font registration globally; guard so repeated renders in a
// single session do not re-register (which leaks fetches).
export function registerReportFonts(): void {
  if (registered) return;
  Font.register({
    family: REPORT_FONT_FAMILY,
    fonts: [
      { src: interRegular, fontWeight: 400 },
      { src: interSemiBold, fontWeight: 600 },
      { src: interBold, fontWeight: 700 },
    ],
  });
  registered = true;
}
